import { useCallback, useEffect, useState } from 'react';
import {
    applyContextMenuSelection,
    handleCardContextMenu,
} from '@/features/tasks/utils/cardSelectionClick';

/**
 * Right-click selection + cursor menu for cards view. Control/Command still
 * toggles without opening the menu (Mac).
 */
export const useCardContextMenu = ({ selectedCount, setSelectedKeys, setAnchorKey }) => {
    const [contextMenu, setContextMenu] = useState(null);

    const closeContextMenu = useCallback(() => setContextMenu(null), []);

    useEffect(() => {
        if (selectedCount === 0) setContextMenu(null);
    }, [selectedCount]);

    const onCardContextMenu = useCallback((event, key, onToggleSelect) => {
        const result = handleCardContextMenu(event, { selectionKey: key, onToggleSelect });
        if (result !== 'menu') return;
        setAnchorKey?.(key);
        setSelectedKeys((prev) => applyContextMenuSelection(prev, key));
        setContextMenu({ x: event.clientX, y: event.clientY });
    }, [setAnchorKey, setSelectedKeys]);

    return { contextMenu, closeContextMenu, onCardContextMenu };
};
